<template>
  <PersonalAreaTemplate
    :max-width="modal ? null : 888"
    :on-save="onSave"
  >
    <div class="notes" :class="{ rowGap: notes.length }">
      <div class="notes_list">
        <div class="notes_list_item" v-for="(i, index) in notes.slice().reverse()" :key="index">
          <div class="notes_list_item_head">{{ i.date }}</div>
          <div v-if="i.text" class="notes_list_item_body" v-html="handleNewLine(i.text)" />
        </div>
      </div>
      <v-form ref="form" class="form" v-model="valid" v-if="editing" lazy-validation @submit.prevent="addNote">
        <div class="inputBox">
          <BaseInput
            type="textarea"
            :label="
              $vuetify.breakpoint.mdAndUp
                ? localStorage.translations.pages['setting-personal_area'].labels['primechanie']
                : null
            "
            :placeholder="
              localStorage.translations.pages['setting-personal_area'].labels['primechanie']
            "
            v-model="inputText"
          />
        </div>
        <BaseButton
          type="submit"
          :text="localStorage.translations.pages['setting-personal_area'].buttons['dobavit']"
          default_icon="button-add"
        />
      </v-form>
    </div>
  </PersonalAreaTemplate>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import PersonalAreaTemplate from 'components/personalArea/personalAreaTemplate'
export default {
  name: 'Note',
  components: { PersonalAreaTemplate },
  props: {
    notesData: Array,
    employeeId: Number,
    onSave: {},
    editing: Boolean,
    modal: Boolean,
  },
  data: () => ({
    valid: true,
    inputText: null,
    notes: [],
  }),
  watch: {
    notesData() {
      if (this.notesData !== null) {
        this.notes = this.notesData
      }
    },
  },
  mounted() {
    if (this.notesData !== null) {
      this.notes = this.notesData
    }
  },
  computed: {
    ...mapGetters(['inputRules']),
  },
  methods: {
    ...mapActions('user', ['onUserUpdateEmployeeData']),
    ...mapActions('employee', ['onEmployeeUpdate']),
    addNote() {
      if (this.inputText) {
        this.notes.push({
          date: new Date().toLocaleString(),
          text: this.inputText,
        })
        this.inputText = null
        this.saveChange()
      }
    },
    handleNewLine(str) {
      return str.replace(/(?:\r\n|\r|\n)/g, '<br />')
    },
    saveChange() {
      let data = {
        notes: JSON.stringify(this.notes),
      }
      if (
        this.$route.name === 'PersonalAreaEmployeeEdit' ||
        this.$route.name === 'PersonalAreaEmployee'
      ) {
        data.id = this.employeeId
        this.onEmployeeUpdate(data)
      } else {
        this.onUserUpdateEmployeeData(data)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.notes {
  display: grid;
  grid-column-gap: 20px;
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    padding: 0;
    border: none;
  }
  &.rowGap {
    grid-row-gap: 20px;
  }
  &_list {
    display: grid;
    grid-row-gap: 20px;
    overflow-y: auto;
    max-height: 450px;
    scrollbar-color: #b4b4b4;
    scrollbar-width: thin;
    &::-webkit-scrollbar {
      width: 8px;
      background: lightgray;
    }

    &::-webkit-scrollbar-thumb {
      background: #b4b4b4;
    }
    &_item {
      &_head {
        font-weight: normal;
        font-size: 14px;
        line-height: 26px;
        color: #858b8e;
      }
      &_body {
        padding: 12px 16px;
        background: #eef9ff;
        border: 1px solid #bedbeb;
        border-radius: 4px;
        font-weight: normal;
        font-size: 16px;
        line-height: 24px;
        color: #2c2c2c;
      }
    }
  }
  .form {
    display: grid;
    grid-column-gap: 20px;
    grid-row-gap: 30px;
  }
}
</style>
